import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { setHeader } from '../../actions/header-actions';
import { ensureSegmentLoaded } from '../../utils/segment';

const identifyUser = (user) => {
    if (window?.analytics) {
        const { email, firstName, lastName } = user;
        window.analytics.identify(user.id, {
            email,
            firstName,
            lastName,
        });
    }
};

const withTracker = (WrappedComponent) => {
    const trackPage = (page, isTrackable, properties, category) => {
        if (isTrackable && window?.analytics) {
            if (category) {
                window.analytics.page(category, page, properties || {});
            } else {
                window.analytics.page(page, properties || {});
            }
        }

        if (window?.pixie) {
            window.pixie('event', 'LandingPage');
        }
    };

    const HOC = class extends Component {
        componentDidMount() {
            const { auth, trackAnonymousUsers } = this.props;
            const page = this.props.location.pathname + this.props.location.search;
            const isTrackable = !!auth.user || trackAnonymousUsers;
            if (isTrackable) {
                ensureSegmentLoaded();
            }
            if (auth.user) {
                identifyUser(auth.user);
            } else if (window?.analytics) {
                const userId = window?.analytics.user && window?.analytics.user().id();
                if (userId) {
                    window.analytics.reset();
                }
            }
            trackPage(page, isTrackable);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            const { setHeaderOptions, auth, trackAnonymousUsers } = this.props;

            const matchedRoutes = matchRoutes(this.props.route.routes, nextProps.location.pathname);
            const nextRoute = matchedRoutes[0]?.route;

            setHeaderOptions(nextRoute?.header ? nextRoute.header : {});

            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;
            const isTrackable = !!auth.user || trackAnonymousUsers;
            const category = trackAnonymousUsers ? nextRoute?.analyticsCategory : undefined;

            if (currentPage !== nextPage) {
                if (currentPage) {
                    trackPage(nextPage, isTrackable, { referrer: currentPage }, category);
                } else {
                    trackPage(nextPage, isTrackable, undefined, category);
                }
            }
        }

        componentDidUpdate(prevProps) {
            const { auth, trackAnonymousUsers } = this.props;
            // Both auth and web_segment_track_anonymous_users resolve asynchronously after mount (no
            // real SSR in this repo) and can arrive in either order. Keying the landing page() off the
            // single "became trackable" transition — rather than off the login and gate-on conditions
            // separately — fires it exactly once, so an authed visitor with the gate on can't get a
            // duplicate page() when the gate resolves before auth does.
            const wasTrackable = !!prevProps.auth.user || prevProps.trackAnonymousUsers;
            const isTrackable = !!auth.user || trackAnonymousUsers;

            if (!wasTrackable && isTrackable) {
                ensureSegmentLoaded();
            }
            if (!prevProps.auth.user && auth.user) {
                identifyUser(auth.user);
            }
            // Fire the landing page() directly (not via trackPage) so the out-of-scope pixie event is
            // not re-sent here.
            if (!wasTrackable && isTrackable && window?.analytics) {
                const page = this.props.location.pathname + this.props.location.search;
                window.analytics.page(page, {});
            }
            if (prevProps.auth.user && !auth.user) {
                if (window?.analytics) {
                    window.analytics.reset();
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    function mapStateToProps({ auth, statsig }) {
        return { auth, trackAnonymousUsers: statsig.trackAnonymousUsers };
    }

    return connect(mapStateToProps, { setHeaderOptions: setHeader })(HOC);
};

export default withTracker;
